<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <ExecutionResultsDialog title="Move Data Source" @close="close()" :shouldClose="!assignOptions.isTestRun" ref="executionResultsDialog" />
    <v-card dark>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Move Data Source</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
    <v-card>
      <v-card-text>
        <v-form ref="form">
          <v-text-field label="Source Name" disabled v-model="formObject.LocationIdentifier" />
          <v-autocomplete v-model="formObject.MonitoringFeatureId" label="Assigned Location" :items="monitoringFeatures" item-value="Id" item-text="DisplayName" />
          <v-checkbox color="error" class="mt-0" v-model="assignOptions.isTestRun" label="Test Run" persistent-hint hint="See logs of the outcome without making any changes" />
          <v-checkbox color="info" class="mt-" v-model="assignOptions.shouldMovePrimaryAlias" label="Move primary alias" persistent-hint hint="Non-primary aliases are always moved. Should the primary alias move too?" />
          <v-checkbox color="info" class="mt-" v-model="assignOptions.canCompromise" label="Can compromise" persistent-hint hint="If the primary alias cannot be moved, or the data sources cannot be merged, a compromise will be attempted. Do a test run to verify that the outcome is as expected." />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-btn color="warning" :loading="loading" @click="unlink()" v-if="formObject.MonitoringFeatureId != null">
          <v-icon class="mr-2">mdi-link-off</v-icon>
          Unlink
        </v-btn>
        <v-spacer />
        <v-btn color="success" :loading="loading" @click="submit()">
          <v-icon class="mr-2">done</v-icon>
          Save
        </v-btn>
        <v-btn depressed :disabled="loading" @click="close()">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  const dataSources = createNamespacedHelpers('datasource')
  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')

  import {
    SOURCE_TYPES_WITH_NAME_INDEX,
  } from '@/store/MonitoringFeature/monitoringfeature'

  export default {
    data: () => ({
      dialog: false,
      formObject: {
        Id: null,
        MonitoringFeatureId: null,
        sourceType: null,
      },
      assignOptions: {
        canCompromise: false,
        shouldMovePrimaryAlias: true,
        isTestRun: true,
      },
      selectedLocation: null,
      loading: false,
    }),
    computed: {
      ...monitoringFeatures.mapGetters(['monitoringFeatures']),
      rules() {
        return {
          hasntSourceType: (v) => {
            if (!v) return true
            let sourceType = this.formObject.sourceType
            return !v.dataTypesIndex[sourceType] ||
              `Location already has a ${SOURCE_TYPES_WITH_NAME_INDEX[sourceType].singularName}`
          },
        }
      },
    },
    watch: {
      selectedLocation(val) {
        if (val) {
          this.formObject.MonitoringFeatureId = val.id
        } else {
          this.formObject.MonitoringFeatureId = null
        }
      },
    },
    methods: {
      ...dataSources.mapActions(['setDSMonitoringFeatureId', 'fetchDataSources', 'unlinkDSMonitoringFeature']),
      ...monitoringFeatures.mapActions(['fetchMonitoringFeaturesUI']),
      close() {
        this.dialog = false
        this.loading = false
      },
      show(dataSource) {
        this.formObject = JSON.parse(JSON.stringify(dataSource))
        this.dialog = true
      },
      async submit() {
        if (!this.$refs.form.validate()) return

        this.loading = true
        try {
          let executionResults = await this.setDSMonitoringFeatureId({
            sourceType: this.formObject.sourceType,
            sourceId: this.formObject.Id,
            monitoringFeatureId: this.formObject.MonitoringFeatureId,
            canCompromise: this.assignOptions.canCompromise,
            shouldMovePrimaryAlias: this.assignOptions.shouldMovePrimaryAlias,
            isTestRun: this.assignOptions.isTestRun,
          })

          this.$refs.executionResultsDialog.show(executionResults)

          let fetchDataSourcesPromise = this.fetchDataSources({
            sourceTypes: [this.formObject.sourceType],
          })
          let fetchMonitoringLocationsPromise = this.fetchMonitoringFeaturesUI()
          await Promise.all([fetchDataSourcesPromise, fetchMonitoringLocationsPromise])
        } catch (error) {
          console.error(error)
          this.$refs.executionResultsDialog.show(error)
        }

        this.loading = false
      },
      async unlink() {
        if (!this.$refs.form.validate()) return

        this.loading = true
        try {
          let executionResults = await this.unlinkDSMonitoringFeature({
            sourceType: this.formObject.sourceType,
            sourceId: this.formObject.Id,
            monitoringFeatureId: null,
            canCompromise: this.assignOptions.canCompromise,
            shouldMovePrimaryAlias: this.assignOptions.shouldMovePrimaryAlias,
            isTestRun: this.assignOptions.isTestRun,
          })

          this.$refs.executionResultsDialog.show(executionResults)

          let fetchDataSourcesPromise = this.fetchDataSources({
            sourceTypes: [this.formObject.sourceType],
          })
          let fetchMonitoringLocationsPromise = this.fetchMonitoringFeaturesUI()
          await Promise.all([fetchDataSourcesPromise, fetchMonitoringLocationsPromise])
        } catch (error) {
          console.error(error)
          this.$refs.executionResultsDialog.show(error)
        }

        this.loading = false
      },
    },
  }
</script>